import React from 'react';
import { Label } from '../atoms/label';
import { Image } from '../atoms/image';
import image_car from '../../resources/icons/ico_car.svg';
import image_pin from '../../resources/icons/ico_location.svg';
export const Address = (props) => {
    
    return(
        <div style={props.style}>
            <Image image={props.kindCar ? image_car : image_pin} style={styles.img}/>
            <Label label={props.text} style={styles.font}/>
        </div>
    );
}
const styles = {
    img:{
        display: "inline",
        position: "absolute",
    },
    font:{
        display: "inline",
        marginLeft: "25px",
        fontSize: "small",
    },
}